import { useEffect, useState } from 'react'
import { formatUnits } from 'ethers/lib/utils'
import { BigNumber } from 'ethers'
import { useRequest } from 'ahooks'
import { useAllTokenPrice } from './useTokenPrice'
import { TICKERS } from '@/constants/token'
import { getDashboard } from '@/api/network'

const useCrossChainVolumn = () => {
  const { data: corssChainHistory } = useRequest(
    async () => {
      const resp = await getDashboard()
      return resp.para
    },
    {
      cacheKey: 'dashboard-info',
    },
  )

  const { data: prices } = useAllTokenPrice()

  const getVolumn = (
    targetToken: string,
    input?: {
      coin: string
      amount: string
    }[],
  ) => {
    return input?.reduce((previousValue, currentValue) => {
      if (currentValue.coin === targetToken) {
        return previousValue.add(currentValue.amount)
      } else {
        return previousValue
      }
    }, BigNumber.from(0))
  }

  const [allOverCrossChainVolume, setAllOverCrossChainVolume] = useState(0)
  const [totalCrossChainVolumeMap, setTotalCrossChainVolumeMap] = useState<Record<string, number | undefined>>({})

  useEffect(() => {
    let _allOverCrossChainVolume = 0
    let _totalCrossChainVolumeMap = {}

    TICKERS.forEach((t) => {
      const volumnOnBtc = getVolumn(t.name, corssChainHistory?.to_btc)
      const volumnOnEvm = getVolumn(t.name, corssChainHistory?.to_evm)

      const price = prices?.[t?.priceInfo?.id]

      if (t.name === 'USD0') {
        if (volumnOnBtc && volumnOnEvm) {
          const volumn = Number(formatUnits(volumnOnBtc, 6)) + Number(formatUnits(volumnOnEvm, 18))

          _totalCrossChainVolumeMap = { ..._totalCrossChainVolumeMap, [t.name]: volumn }

          if (price) {
            _allOverCrossChainVolume += volumn * price
          }
        } else {
          _totalCrossChainVolumeMap = { ..._totalCrossChainVolumeMap, [t.name]: undefined }
        }
      } else {
        if (volumnOnBtc && volumnOnEvm) {
          const volumn = Number(formatUnits(volumnOnBtc.add(volumnOnEvm)))

          _totalCrossChainVolumeMap = { ..._totalCrossChainVolumeMap, [t.name]: volumn }

          if (price) {
            _allOverCrossChainVolume += volumn * price
          }
        } else {
          _totalCrossChainVolumeMap = { ..._totalCrossChainVolumeMap, [t.name]: undefined }
        }
      }
    })

    setTotalCrossChainVolumeMap(_totalCrossChainVolumeMap)
    setAllOverCrossChainVolume(_allOverCrossChainVolume)
  }, [corssChainHistory?.to_btc, corssChainHistory?.to_evm, prices])

  return { allOverCrossChainVolume, totalCrossChainVolumeMap }
}

export default useCrossChainVolumn
